import React from 'react'
import PropTypes from 'prop-types'
import Dropzone from 'react-fine-uploader/dropzone'
import FileInput from 'react-fine-uploader/file-input'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'

const useStyles = makeStyles(theme => ({
  dropZone: {
    cursor: 'pointer',
    margin: 0,
    height: 'fit-content',
    width: '100%',
    backgroundColor: '#fff',
    '&.dropzoneActive > $fileInput': {
      borderColor: theme.activeInputBorder,
      background: '#fafbff',
    },
  },
  fileInput: {
    cursor: 'pointer',
    margin: 0,
    width: '100%',
    height: 'calc(100% + 4px)',
    borderRadius: 3,
    border: `2px dashed ${theme.borderColor}`,
    '&:hover': {
      borderColor: theme.activeInputBorder,
      background: '#fafbff',
      borderWidth: 2,
    },
    '& > input': {
      cursor: 'pointer',
    },
  },
}))

const DropZoneUploader = (props) => {
  const { accept, uploader, children, multiple, className, classNameInput, onDropError } = props
  const classes = useStyles(props)

  const acceptString = accept.constructor.name === 'Array'
    ? accept[0]?.startsWith('.') ? accept.join(', ') : accept.map((ext) => `.${ext}`).join(', ')
    : accept

  const onError = (error) => {
    onDropError && onDropError(error)
  }

  return (
    <Dropzone className={clsx(classes.dropZone, className)} dropActiveClassName="dropzoneActive" onDropError={onError} uploader={uploader} multiple={multiple}>
      <FileInput className={clsx(classes.fileInput, classNameInput)} uploader={uploader} accept={acceptString} multiple={multiple}>
        {children}
      </FileInput>
    </Dropzone>
  )
}

DropZoneUploader.propTypes = {
  accept: PropTypes.arrayOf(PropTypes.string),
  multiple: PropTypes.bool,
  uploader: PropTypes.object,
  className: PropTypes.string,
  classNameInput: PropTypes.string,
  onDropError: PropTypes.func,
  children: PropTypes.node,
}

DropZoneUploader.defaultProps = {
  accept: [],
  className: '',
  classNameInput: '',
  multiple: true,
}

export default DropZoneUploader
